import React from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
  } from '@chakra-ui/react'
  import AssessmentDataService from "../../services/Assessment";
export const DeleteModal = ({isOpen,onClose, id, func}:any) => {
  const  token = localStorage.getItem("logged_in_user_token");
  const deleteAssessments = () => {
    AssessmentDataService.delete(id,token)
      .then((response: any) => {
        func(true);
       onClose();
      })
      .catch((e: Error) => {
        console.log(e);
      });
  }
  return (
    <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Delete Assessment</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
          Are you sure you want to delete this assessment?
          </ModalBody>

          <ModalFooter>
          <Button  bgColor='#327171' color={"white"} mr={3} onClick={deleteAssessments} >Delete</Button>
            <Button  bgColor='red' color={"white"} mr={3} onClick={onClose}>
              No
            </Button>
           
          </ModalFooter>
        </ModalContent>
      </Modal>
  )
}
